import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=6fb895d1"
import script from "./StatusChip.vue?vue&type=script&lang=js"
export * from "./StatusChip.vue?vue&type=script&lang=js"
import style0 from "./StatusChip.vue?vue&type=style&index=0&id=6fb895d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports